import { FiCheck } from 'react-icons/fi';
import { PRESETS } from './presets';

const EASE_OUT = 'cubic-bezier(0.23, 1, 0.32, 1)';

/**
 * Row horizontal de cards de preset com micro-feedback e stagger entrada.
 * Click → onSelect(preset). activeId marca o card aplicado.
 */
export default function PresetCards({ onSelect, activeId }) {
  return (
    <>
      <div className="flex gap-3 overflow-x-auto pb-2">
        {PRESETS.map((p, i) => {
          const active = activeId === p.id;
          return (
            <button
              key={p.id}
              type="button"
              onClick={() => onSelect(p)}
              data-active={active}
              className={[
                'group relative min-w-[240px] flex-shrink-0 rounded-xl border p-4 text-left',
                'transition-[transform,border-color,background-color,box-shadow] duration-200',
                'active:scale-[0.97]',
                active ? 'bg-primary/[0.04] border-primary shadow-sm' : 'hover:border-primary/40 border-neutral-lightest bg-white hover:shadow-sm'
              ].join(' ')}
              style={{
                transitionTimingFunction: EASE_OUT,
                animation: `preset-in 320ms ${EASE_OUT} both`,
                animationDelay: `${i * 40}ms`
              }}
            >
              <div className="flex items-start justify-between gap-3">
                <div className="text-sm font-semibold text-primary-dark">{p.label}</div>
                {active && (
                  <span
                    className="flex size-5 shrink-0 items-center justify-center rounded-full bg-primary text-white"
                    style={{ animation: `check-in 240ms ${EASE_OUT}` }}
                  >
                    <FiCheck
                      className="size-3"
                      strokeWidth={3}
                    />
                  </span>
                )}
              </div>
              <div className="mt-1 text-xs leading-relaxed text-neutral">{p.description}</div>
            </button>
          );
        })}
      </div>
    </>
  );
}

// Inject keyframes once (preset-in for stagger, check-in for active indicator)
if (typeof window !== 'undefined' && !document.getElementById('preset-kf')) {
  const s = document.createElement('style');
  s.id = 'preset-kf';
  s.textContent = `
    @keyframes preset-in {
      from { opacity: 0; transform: translateY(8px); }
      to { opacity: 1; transform: translateY(0); }
    }
    @keyframes check-in {
      from { opacity: 0; transform: scale(0.6); }
      to { opacity: 1; transform: scale(1); }
    }
    @media (prefers-reduced-motion: reduce) {
      @keyframes preset-in { from { opacity: 0; } to { opacity: 1; } }
      @keyframes check-in { from { opacity: 0; } to { opacity: 1; } }
    }
  `;
  document.head.appendChild(s);
}
